<template>
  <DataList
    title="Товари та матеріали"
    resource="sales-products"
    :columns="columns"
    :get-items-fn="getProducts"
  />
</template>

<script>
import DataList from "../../../components/DataList.vue";
import * as productsApi from "../../backend/productsApi.js";

export default {
  components: {
    DataList,
  },
  data: () => ({
    columns: [
      { title: "Найменування", name: "title" },
      { title: "Повне найменування", name: "fullTitle" },
      { title: "Найменування для сайту", name: "siteTitle" },
      { title: "Одиниці виміру", name: "unitTitle" },
      { title: "Картинка", name: "picture" },
    ],
  }),
  methods: {
    async getProducts(...args) {
      const data = await productsApi.getProducts(args[0], args[1], args[2], args[3]);
      data.result = data.result.map(e=>{
        return {
          id: e.id,
          title: e.title,
          fullTitle: e.fullTitle,
          siteTitle: e.siteTitle,
          unitTitle: e.unit ? e.unit.title : "",
          picture: e.picture,
        };
      });
      return data;
    },
  },
};
</script>